import NextLink from "@/components/case-study/common/NextLink";
import About from "@/components/case-study/mobifinx/About";
import Guidelines from "@/components/case-study/mobifinx/Guidelines";
import Hero from "@/components/case-study/mobifinx/Hero";
import ResponsiveUI from "@/components/case-study/mobifinx/ResponsiveUI";
import ResultsAndOutcome from "@/components/case-study/mobifinx/ResultsAndOutcome";
import Solutions from "@/components/case-study/mobifinx/Solutions";
import Technology from "@/components/case-study/mobifinx/Technology";
import Testimonials from "@/components/case-study/mobifinx/Testimonials";
import Ui from "@/components/case-study/mobifinx/UI";
import Layout from "@/components/layout/Layout";

const MobifinX = () => (
  <Layout
    description="MobifinX is an advanced, secured, scalable, robust, and flexible Digital Asset Trading Platform. It is a leading digital asset suite offering well-tested, compliant, intuitive blockchain products with bank-grade security."
    title="MobifinX- Blockchain technology with trading solutions"
  >
    <Hero />
    <About />
    <Solutions />
    <Guidelines />
    <Ui />
    <ResponsiveUI />
    <Technology />
    <ResultsAndOutcome />
    <Testimonials />
    <NextLink
      nextImg="/assets/case-study/next-case-study/go-cyclists.webp"
      nextLink="/portfolio/go-cyclists-marketplace-app-case-study"
      nextTitle="Next <br/> case Study"
    />
  </Layout>
);
export default MobifinX;
